import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
import loadConfig from "@Web3WalletConfig/config";
export default {
  name: "gift",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", 'setting'])
  },
  data() {
    return {
      loadConfig,
      isLock: false,
      list: {},
      popTaskShow: false,
      modifyData: {
        "icon": ""
      },
      isLoading: false,
      selectTab: 0
    };
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let rs = await this.$http.post("/luckylottery", {
        status: this.selectTab == 0 ? 1 : 0
      });
      this.isLoading = false;
      if (rs.code == 0) {
        this.list = rs.data;
      }
    },
    async onCreate() {
      this.modifyData = {
        "provider": "official",
        "icon": "",
        'status': "1",
        "type": '0',
        "custom_logic_enabled": 0,
        "count_options": "[1]"
      };
      this.popTaskShow = true;
    },
    onCustemLogicReward(id) {
      this.$router.push("/luckylotteryitemscustem?id=" + id);
    },
    onReward(id) {
      this.$router.push("/luckylotteryitems?id=" + id);
    },
    async onModify(item) {
      this.modifyData = item;
      this.popTaskShow = true;
    },
    onLogs(id) {
      this.$router.push("/luckylotterylogs?lottery_id=" + id);
    },
    cutStr(str) {
      if (str) return str.replace("T", " ").replace(".000Z", "");
    },
    onRefresh() {
      this.getData();
    }
  },
  mounted() {
    this.getData();
  }
};